/* eslint-disable no-sequences */
import React from "react";
export default function PopupConfig() {
  const [popupConfig, setPopupConfig] = React.useState({
    popupVisible: false,
    positionOf: "",
    createdAt: Date.now(),
    data: {},
  });

  const handleOpenPopup = (data) => {
    setPopupConfig({
      data: data,
      positionOf: {
        my: "center center",
        at: "center center",
      },
      popupVisible: true,
    });
  };

  const handleClosePopup = () => {
    setPopupConfig({
      popupVisible: false,
    });
  };
  return { handleOpenPopup, handleClosePopup, popupConfig };
}
